import { j as x } from "./jsx-runtime-944c88e2.js";
import * as i from "react";
import { p as l } from "./index-efd35e77.js";
import { l as K, v as B } from "./index-64063129.js";
import { x as H, O as q, P as F, Q as G, K as W } from "./index.es-6889c727.js";
import { A as Q } from "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "react-dom";
var Z = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, r) {
      o.__proto__ = r;
    } || function(o, r) {
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (o[a] = r[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), E = globalThis && globalThis.__assign || function() {
  return E = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, E.apply(this, arguments);
}, J = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}, V = (
  /** @class */
  function(e) {
    Z(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n = this.props, o = n.children, r = J(n, ["children"]), a = {
        transitionName: "fade"
      };
      return i.createElement(Q, E({}, a, r), o);
    }, t.propTypes = {
      children: l.oneOfType([
        l.arrayOf(l.node),
        l.node
      ]),
      childFactory: l.any,
      className: l.string,
      component: l.string,
      id: l.string,
      style: l.any
    }, t.defaultProps = {
      appear: !1,
      enter: !0,
      exit: !1,
      transitionEnterDuration: 500,
      transitionExitDuration: 500
    }, t;
  }(i.Component)
), C = {
  name: "@progress/kendo-react-notification",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686226557,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, z = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = {}, o = function(a) {
    return typeof a == "object" ? Object.keys(a).forEach(function(s) {
      n[s] = a[s];
    }) : n[a] = !0;
  }, r = function(a) {
    return a.filter(function(s) {
      return s !== !0 && !!s;
    }).map(function(s) {
      return Array.isArray(s) ? r(s) : o(s);
    });
  };
  return r(e), Object.keys(n).map(function(a) {
    return n[a] && a || null;
  }).filter(function(a) {
    return a !== null;
  }).join(" ");
}, X = function(e, t, n) {
  n === void 0 && (n = {});
  var o = i.useCallback(function(c) {
    n.onMouseDown && n.onMouseDown.call(void 0, c), e.onMouseDown && e.onMouseDown.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseDown, e.onMouseDown, t]), r = i.useCallback(function(c) {
    n.onMouseUp && n.onMouseUp.call(void 0, c), e.onMouseUp && e.onMouseUp.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseUp, e.onMouseUp, t]), a = i.useCallback(function(c) {
    n.onClick && n.onClick.call(void 0, c), e.onClick && e.onClick.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onClick, e.onClick, t]), s = i.useCallback(function(c) {
    n.onDoubleClick && n.onDoubleClick.call(void 0, c), e.onDoubleClick && e.onDoubleClick.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onDoubleClick, e.onDoubleClick, t]), v = i.useCallback(function(c) {
    n.onMouseEnter && n.onMouseEnter.call(void 0, c), e.onMouseEnter && e.onMouseEnter.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseEnter, e.onMouseEnter, t]), u = i.useCallback(function(c) {
    n.onMouseLeave && n.onMouseLeave.call(void 0, c), e.onMouseLeave && e.onMouseLeave.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseLeave, e.onMouseLeave, t]), f = i.useCallback(function(c) {
    n.onMouseMove && n.onMouseMove.call(void 0, c), e.onMouseMove && e.onMouseMove.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseMove, e.onMouseMove, t]), m = i.useCallback(function(c) {
    n.onMouseOut && n.onMouseOut.call(void 0, c), e.onMouseOut && e.onMouseOut.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseOut, e.onMouseOut, t]), y = i.useCallback(function(c) {
    n.onMouseOver && n.onMouseOver.call(void 0, c), e.onMouseOver && e.onMouseOver.call(void 0, {
      target: t.current,
      syntheticEvent: c
    });
  }, [n.onMouseOver, e.onMouseOver, t]);
  return {
    onClick: a,
    onMouseUp: r,
    onMouseDown: o,
    onDoubleClick: s,
    onMouseEnter: v,
    onMouseLeave: u,
    onMouseMove: f,
    onMouseOut: m,
    onMouseOver: y
  };
}, R = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, j = globalThis && globalThis.__assign || function() {
  return j = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, j.apply(this, arguments);
}, Y = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}, I = i.forwardRef(function(e, t) {
  var n = e.className, o = e.name, r = e.themeColor, a = e.size, s = e.flip, v = e.style, u = e.id, f = e.tabIndex, m = Y(e, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), y = i.useRef(null), c = i.useRef(null);
  i.useImperativeHandle(y, function() {
    return {
      element: c.current
    };
  }), i.useImperativeHandle(t, function() {
    return y.current;
  });
  var b = i.useMemo(function() {
    return a || D.size;
  }, [a]), d = i.useMemo(function() {
    return s || D.flip;
  }, [s]), _ = i.useMemo(function() {
    var h;
    return z("k-icon", o && te(o), (h = {}, h["k-color-".concat(r)] = r, h["k-flip-h"] = d === "horizontal" || d === "both", h["k-flip-v"] = d === "vertical" || d === "both", h), R[b], n);
  }, [o, r, b, d, n]), M = X(e, y);
  return i.createElement("span", j({ ref: c }, m, M, { className: _, id: u, tabIndex: f, style: v, role: "presentation" }));
});
I.propTypes = {
  style: l.object,
  classNames: l.string,
  name: l.string,
  themeColor: l.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: l.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: l.oneOf(["default", "horizontal", "vertical", "both"])
};
var D = {
  size: "default",
  flip: "default"
};
I.displayName = "KendoIcon";
var g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, g.apply(this, arguments);
}, ee = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}, S = i.forwardRef(function(e, t) {
  var n = e.children, o = e.className, r = e.svgClassName, a = e.icon, s = e.flip, v = e.id, u = e.tabIndex, f = e.size, m = e.style, y = e.svgStyle, c = e.themeColor, b = e.viewBox;
  e.name;
  var d = ee(e, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name"]), _ = i.useRef(null);
  i.useImperativeHandle(t, function() {
    return {
      element: _.current
    };
  });
  var M = i.useMemo(function() {
    return a ? a.name : w.icon;
  }, [a]), h = i.useMemo(function() {
    return f || w.size;
  }, [f]), p = i.useMemo(function() {
    return s || w.flip;
  }, [s]), U = i.useMemo(function() {
    return b || w.viewBox;
  }, [b]), A = i.useMemo(function() {
    var O;
    return z("k-svg-icon", "k-svg-i-" + M, (O = {}, O["k-color-".concat(c)] = c, O["k-flip-h"] = p === "horizontal" || p === "both", O["k-flip-v"] = p === "vertical" || p === "both", O), R[h], o);
  }, [M, c, h, p, o]), $ = i.useMemo(function() {
    return e.width && e.height ? g({ width: e.width, height: e.height }, m) : e.width ? g({ width: e.width, height: e.width }, m) : e.height ? g({ width: e.height, height: e.height }, m) : g({}, m);
  }, [e.width, e.height, m]);
  return i.createElement(
    "span",
    { className: A, style: $, ref: _ },
    i.createElement("svg", g({ id: v, className: r, style: y, "aria-hidden": !0, tabIndex: u, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: a ? a.viewBox : U, dangerouslySetInnerHTML: a ? { __html: a.content } : void 0 }, d), a ? void 0 : n)
  );
});
S.propTypes = {
  style: l.object,
  classNames: l.string,
  children: l.any,
  icon: l.object,
  themeColor: l.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: l.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: l.oneOf(["default", "horizontal", "vertical", "both"])
};
var w = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
S.displayName = "KendoSvgIcon";
var L = i.createContext({ type: "svg" });
L.displayName = "KendoReactIconsContext";
var k = globalThis && globalThis.__assign || function() {
  return k = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, k.apply(this, arguments);
}, ne = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}, N = i.forwardRef(function(e, t) {
  var n, o = i.useContext(L), r = o.type, a = o.icons, s = e.icon, v = ne(e, ["icon"]), u = ((n = e.icon) === null || n === void 0 ? void 0 : n.name) || e.name, f = u && a && a[u] && typeof a[u] != "string" ? a[u] : s;
  return u = u && a && a[u] && typeof a[u] == "string" ? a[u] : u, r === "svg" && f ? i.createElement(S, k({}, e, { icon: f, ref: t })) : i.createElement(I, k({}, v, { name: u, ref: t }));
});
N.displayName = "KendoIconWrap";
var te = function(e) {
  return "k-i-" + e;
};
l.shape({
  name: l.string.isRequired,
  content: l.string.isRequired,
  viewBox: l.string.isRequired
});
var oe = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, r) {
      o.__proto__ = r;
    } || function(o, r) {
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (o[a] = r[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), T = globalThis && globalThis.__assign || function() {
  return T = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, T.apply(this, arguments);
}, re = "Close", ae = {
  success: "check-outline",
  error: "x-outline",
  info: "info-circle",
  warning: "exclamation-circle"
}, ie = {
  success: q,
  error: F,
  info: G,
  warning: W
}, le = (
  /** @class */
  function(e) {
    oe(t, e);
    function t(n) {
      var o = e.call(this, n) || this;
      if (typeof K < "u")
        B(C);
      else {
        var r = "License activation failed for ".concat(C.name, `
`);
        r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(C.licensingDocsUrl, ` for more information.
`), console.warn(r);
      }
      return o;
    }
    return t.prototype.render = function() {
      var n = this, o = this.props, r = o.onClose, a = o.className, s = o.closable, v = s === void 0 ? t.defaultProps.closable : s, u = o.type, f = u === void 0 ? t.defaultProps.type : u;
      return i.createElement(
        "div",
        { dir: this.props.dir, className: "k-notification-container" },
        i.createElement(
          "div",
          { className: "k-notification" + (a ? " ".concat(a) : "") + (f.style === "none" ? "" : " k-notification-".concat(f.style)) + (v ? " k-notification-closable" : ""), style: this.props.style },
          f.icon && i.createElement(N, { className: "k-notification-status", name: ae[f.style], icon: ie[f.style] }),
          i.createElement("div", { className: "k-notification-content" }, this.props.children),
          i.createElement("span", { className: "k-notification-actions" }, v && i.createElement(
            "span",
            T({ className: "k-notification-action k-notification-close-action", title: re, onClick: function(m) {
              r && r.call(void 0, {
                target: n,
                syntheticEvent: m,
                nativeEvent: m.nativeEvent
              });
            } }, typeof v != "boolean" ? v : {}),
            i.createElement(N, { name: "x", icon: H })
          ))
        )
      );
    }, t.propTypes = {
      className: l.string,
      closable: l.oneOfType([l.bool, l.object]),
      dir: l.string,
      style: l.object,
      type: l.shape({
        style: l.oneOf(["none", "success", "error", "warning", "info"]),
        icon: l.bool
      }),
      onClose: l.func
    }, t.defaultProps = {
      closable: !1,
      type: {
        style: "none",
        icon: !0
      }
    }, t;
  }(i.Component)
), ce = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, r) {
      o.__proto__ = r;
    } || function(o, r) {
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (o[a] = r[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), P = globalThis && globalThis.__assign || function() {
  return P = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, P.apply(this, arguments);
}, se = (
  /** @class */
  function(e) {
    ce(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var n = this.props, o = n.style, r = o === void 0 ? {} : o, a = n.className;
      return i.createElement("div", { className: "k-notification-group" + (a ? " ".concat(a) : ""), style: P({ alignItems: "center", flexWrap: "wrap" }, r) }, this.props.children);
    }, t.propTypes = {
      className: l.string,
      style: l.object
    }, t;
  }(i.Component)
);
const ge = (e) => /* @__PURE__ */ x.jsx(V, { children: !e.closed && /* @__PURE__ */ x.jsx(
  le,
  {
    ...e,
    type: { style: e.alertType ?? "info", icon: e.showIcon ?? !0 }
  }
) }), be = (e) => /* @__PURE__ */ x.jsx(se, { ...e });
export {
  ge as Alert,
  be as AlertGroup
};
